const SET_CLIENT_KEY = (state, payload) => {
    state.client_key = '';
    state.client_key = payload;
}
const CLEAR_CLIENT_KEY = (state) => {
    state.client_key = '';
}

const SET_INTENT_KEY = (state, payload) => {
    state.intent_key = '';
    state.intent_key = payload;
}
const CLEAR_INTENT_KEY = (state) => {
    state.intent_key = '';
}

const SET_ITEM_CHARGE = (state, payload) => {
    state.item_charge = '';
    state.item_charge = payload;
}
const CLEAR_ITEM_CHARGE = (state) => {
    state.item_charge = '';
}

const SET_SUBSCRIPTION = (state, payload) => {
    state.subscription = {};
    state.subscription = payload;
}
const CLEAR_SUBSCRIPTION = (state) => {
    state.item_charge = {};
}

const SET_SUBSCRIPTION_INFO = (state, payload) => {
    state.subscription_info = {};
    state.subscription_info = payload;
}

const CLEAR_SUBSCRIPTION_INFO = (state) => {
    state.subscription_info = {};
}

const SET_RECEIPT_SOURCE = (state, payload) => {
    state.receipt_source = {};
    state.receipt_source = payload;
}

const CLEAR_RECEIPT_SOURCE = (state) => {
    state.receipt_source = {};
}

const SET_SUCCESS_FLAG = (state, payload) => {
    state.success_flag = '';
    state.success_flag = payload;
}
const CLEAR_SUCCESS_FLAG = (state) => {
    state.success_flag = '';
}

const SET_FREE_MONTH = (state, payload) => {
    state.free_month = '';
    state.free_month = payload;
}
const CLEAR_FREE_MONTH = (state) => {
    state.free_month = '';
}

const SET_UPDATE_CC = (state, payload) => {
    state.update_cc = '';
    state.update_cc = payload;
}
const CLEAR_UPDATE_CC = (state) => {
    state.update_cc = '';
}

const SET_UPDATE_CC_RESULT = (state, payload) => {
    state.update_cc_result = '';
    state.update_cc_result = payload;
}
const CLEAR_UPDATE_CC_RESULT = (state) => {
    state.update_cc_result = '';
}

const SET_AUTO_SYNC_SUBSCRIPTION = (state, payload) => {
    state.auto_sync_subscription = '';
    state.auto_sync_subscription = payload;
}
const CLEAR_AUTO_SYNC_SUBSCRIPTION = (state) => {
    state.auto_sync_subscription = '';
}

const SET_PENDING_AUTO_SYNC = (state, payload) => {
    state.pending_auto_sync = '';
    state.pending_auto_sync = payload;
}
const CLEAR_PENDING_AUTO_SYNC = (state) => {
    state.pending_auto_sync = '';
}

const SET_UPDATE_SUBSCRIPTION = (state, payload) => {
    state.update_subscription = {};
    state.update_subscription = payload;
}
const CLEAR_UPDATE_SUBSCRIPTION = (state) => {
    state.update_subscription = {};
}

const SET_READ_AGREEMENT = (state, payload) => {
    state.read_agreement = '';
    state.read_agreement = payload;
}
const CLEAR_READ_AGREEMENT = (state) => {
    state.read_agreement = '';
}

const CLEAR_STATES = (state) => {
    state.intent_key = '';
}

const SET_SETUP_INTENT = (state, payload) => {
    state.setup_intent = payload || {};
};

export {
    SET_CLIENT_KEY,
    CLEAR_CLIENT_KEY,
    SET_INTENT_KEY,
    CLEAR_INTENT_KEY,
    SET_ITEM_CHARGE,
    CLEAR_ITEM_CHARGE,
    SET_SUBSCRIPTION,
    CLEAR_SUBSCRIPTION,
    SET_SUBSCRIPTION_INFO,
    CLEAR_SUBSCRIPTION_INFO,
    SET_RECEIPT_SOURCE,
    CLEAR_RECEIPT_SOURCE,
    SET_SUCCESS_FLAG,
    CLEAR_SUCCESS_FLAG,
    SET_FREE_MONTH,
    CLEAR_FREE_MONTH,
    SET_UPDATE_CC,
    CLEAR_UPDATE_CC,
    SET_UPDATE_CC_RESULT,
    CLEAR_UPDATE_CC_RESULT,
    SET_UPDATE_SUBSCRIPTION,
    CLEAR_UPDATE_SUBSCRIPTION,
    SET_AUTO_SYNC_SUBSCRIPTION,
    CLEAR_AUTO_SYNC_SUBSCRIPTION,
    SET_PENDING_AUTO_SYNC,
    CLEAR_PENDING_AUTO_SYNC,
    SET_READ_AGREEMENT,
    CLEAR_READ_AGREEMENT,
    CLEAR_STATES,
    SET_SETUP_INTENT
}
